import type { BdfJob } from '@infinitform/platform-core';

// Master menu collapses to "Manage / Download BDFs"; single-project label
// follows the job state so the row can drive the user to the next action.
export function bdfMenuLabel(
  isMaster: boolean,
  childrenAllDone: boolean,
  job: BdfJob | null,
): string {
  if (isMaster) return childrenAllDone ? 'Download BDFs' : 'Manage BDFs';
  if (!job) return 'Generate BDF';
  switch (job.status) {
    case 'queued':  return 'BDF queued…';
    case 'running': return typeof job.progress === 'number'
      ? `Generating BDF… ${job.progress}%`
      : 'Generating BDF…';
    case 'done':    return (job.s3Key || job.localPath) ? 'Download BDF' : 'Generate BDF';
    case 'error':   return 'Retry BDF';
    default:        return 'Generate BDF';
  }
}

// Master menu always opens the modal; single-project menu locks while in flight.
export function bdfMenuDisabled(isMaster: boolean, job: BdfJob | null): boolean {
  if (isMaster) return false;
  return job?.status === 'queued' || job?.status === 'running';
}
